<script setup>
import { useCalculateScrollProgress, ref, useDevice } from '#imports';

const isHover = ref(false);
const isDesktop = useDevice();

const props = defineProps({
  bottomOffset: {
    type: Number,
    default: 0,
  },
  forceHideBottomOffset: {
    type: Number,
    default: 0,
  },
});

const { progress, forceHideProgress } = useCalculateScrollProgress({
  bottomOffset: props.bottomOffset,
  forceHideBottomOffset: props.forceHideBottomOffset,
});
</script>

<template>
  <ClientOnly>
    <template v-if="isDesktop">
      <Transition name="fade">
        <div
          v-show="progress > 1 && forceHideProgress < 100"
          class="progress-bar"
          @mouseenter="isHover = true"
          @mouseleave="isHover = false"
          @focusin="isHover = true"
          @focusout="isHover = false"
        >
          <ProgressBarIndicator :filling-percent="Number(progress)" />
          <Transition name="fast-fade">
            <div
              v-if="progress < 100 && !isHover"
              class="progress-bar__icon progress-bar__icon--indicator"
            ></div>
          </Transition>
          <Transition name="fast-fade">
            <ProgressBarScrollTop
              v-if="progress >= 100 || isHover"
              class="progress-bar__icon progress-bar__icon--top"
            />
          </Transition>
        </div>
      </Transition>
    </template>
  </ClientOnly>
</template>

<style lang="postcss" scoped>
.progress-bar {
  position: relative;
  z-index: 1;

  &__icon {
    position: absolute;
    top: auto;
    bottom: 0;
    left: 50%;
    right: 0;
    transform: translateX(-50%);
    cursor: pointer;

    &--indicator {
      background-image: url('~/assets/images/power.svg');
      width: 121px;
      height: 121px;
    }

    &--top {
      top: 0;
    }
  }

  @media (--small-vp) {
    display: none;
  }
}
</style>
